"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.affiliationPath = void 0;
const org_club_1 = require("./org-club");
const org_ngb_1 = require("./org-ngb");
exports.affiliationPath = [
    {
        organization_id: org_club_1.orgClub.id,
        organization_name: org_club_1.orgClub.name,
        classification: 'Club'
    },
    {
        organization_id: org_ngb_1.orgNgb.id,
        organization_name: org_ngb_1.orgNgb.name,
        classification: null
    }
];
